import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-safely',
  templateUrl: './safely.component.html',
  styles: ``,
})
export class SafelyComponent {
  public AppPermission = AppPermission;
}
